import styles from "./Valuation.module.scss";
import { FC } from "react";
import VersusBar from "@/components/versus-bar/VersusBar";
import { withStockStamp } from "@/components/stock-stamp-hoc/StockStampHOC";
import { classNames } from "@/lib/utils";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";

interface PropsTypes {
    value: number;
    vsIndustry: number[];
    vsHistory: number[];
    type?: string;
    overviewPage?: boolean;
    mobile?: boolean;
}

const Valuation: FC<PropsTypes> = ({ value, vsIndustry, vsHistory, type, overviewPage, mobile }) => {
    return (
        <div className={classNames(styles.Valuation, styles[overviewPage && "overview-page"])}>
            <Box sx={overviewPage && { height: "20%" }}>
                <Typography variant={mobile ? "h2" : "moduleContentTitle"} className={styles.value}>
                    {value}
                </Typography>
            </Box>
            <Box sx={overviewPage ? { width: "90%", height: "80%", marginX: "auto" } : { height: "80%", display: "flex", flexDirection: "column", justifyContent: "space-around", px: "3px" }}>
                <VersusBar title="vs Industry" data={vsIndustry} value={value} bigFont={overviewPage} />
                <VersusBar title="vs History" data={vsHistory} value={value} bigFont={overviewPage} />
            </Box>
        </div>
    );
};

export default withStockStamp(Valuation, "value", { title: "(12M FWD)", align: "center" }, "Valuation");
